export const environment = {
  production: true,
  publicConfigUrl: '/api/public/configuration',
  localDevSsoRedirect: false,
  ssoLoginRedirectIntervalInHours: 24,

  sentryDisabledOnUrls: new RegExp('^(?!.*(?:rpqa20-gi.rampitplatform.com|rpqa20-postman.rampitplatform.com|localhost)).*$'),
  // sentry config
  sentry: {
    DSN: "https://da94567478e3b0e81d60f1ab0da6a079@o4504165036457984.ingest.us.sentry.io/4507769006260224",
    // environment setting needs to be updated as per the environment this is deployed to
    environment: 'prod',
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  }
};
